import { createIcon } from '@chakra-ui/react';

export const DashboardBoldIcon = createIcon({
  displayName: 'DashboardBoldIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="16"
        // height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <path
          d="M4.82683 1.83331H3.56016C2.10016 1.83331 1.3335 2.59998 1.3335 4.05331V5.31998C1.3335 6.77331 2.10016 7.53998 3.5535 7.53998H4.82016C6.2735 7.53998 7.04016 6.77331 7.04016 5.31998V4.05331C7.04683 2.59998 6.28016 1.83331 4.82683 1.83331Z"
          fill="#2B2448"
        />
        <path
          d="M12.4466 1.83331H11.18C9.72663 1.83331 8.95996 2.59998 8.95996 4.05331V5.31998C8.95996 6.77331 9.72663 7.53998 11.18 7.53998H12.4466C13.9 7.53998 14.6666 6.77331 14.6666 5.31998V4.05331C14.6666 2.59998 13.9 1.83331 12.4466 1.83331Z"
          fill="#2B2448"
        />
        <path
          d="M12.4466 9.45331H11.18C9.72663 9.45331 8.95996 10.22 8.95996 11.6733V12.94C8.95996 14.3933 9.72663 15.16 11.18 15.16H12.4466C13.9 15.16 14.6666 14.3933 14.6666 12.94V11.6733C14.6666 10.22 13.9 9.45331 12.4466 9.45331Z"
          fill="#2B2448"
        />
        <path
          d="M4.82683 9.45331H3.56016C2.10016 9.45331 1.3335 10.22 1.3335 11.6733V12.94C1.3335 14.4 2.10016 15.1666 3.5535 15.1666H4.82016C6.2735 15.1666 7.04016 14.4 7.04016 12.9466V11.68C7.04683 10.22 6.28016 9.45331 4.82683 9.45331Z"
          fill="#2B2448"
        />
      </svg>
    </>
  ),
});
